import { render, staticRenderFns } from "./UserFieldGroupEditForm.vue?vue&type=template&id=467c06ea&scoped=true&"
import script from "./UserFieldGroupEditForm.vue?vue&type=script&lang=js&"
export * from "./UserFieldGroupEditForm.vue?vue&type=script&lang=js&"
import style0 from "./UserFieldGroupEditForm.vue?vue&type=style&index=0&id=467c06ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467c06ea",
  null
  
)

export default component.exports